import { myDotContracts } from './constants';

export const isMyDotAddress = (address?: string) =>
  !!address &&
  myDotContracts.some(
    (item) => item.toLowerCase() === address.toLowerCase(),
  );
